import { formatDistanceToNow } from 'date-fns';
import { dateFnsLocale } from './i18nDate';

// Jedna mapa języków dla całej aplikacji (`i18nDate.ts`). Własna mapa tutaj nie znała
// białoruskiego i w `by` karty pisały „3 months ago” (kontrola na żywo 30.09).
const localeFor = (lng: string) => dateFnsLocale(lng.slice(0, 2));

/**
 * Relative "posted" time for offer cards/popups. Special-cases the 1-day bucket
 * to "yesterday" — date-fns would render "1 day ago" / "1 dzień temu", which
 * reads worse. Everything else uses date-fns with the locale + "ago" suffix.
 */
export function formatPostedRelative(iso: string, lng: string, t: (key: string) => string): string {
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  const DAY = 86_400_000;
  if (diffMs >= DAY && diffMs < 2 * DAY) return t('search.card.yesterday');
  return formatDistanceToNow(date, { addSuffix: true, locale: localeFor(lng) });
}
